import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useRef } from 'react';
import Screens from '../screens';
import { MISSIONS_GAMEPLAY_STATUS } from '../screens/Missions/constants';
import { generateDescription } from '../screens/Missions/utils/generateMissionCardDataRendering';
import { hasSomeCompleteState } from '../screens/Missions/utils/missionsPerformance';
import utils from '../utils';
import QueryParamsProxy from '../utils/queryParamProxy';
import { useSelector } from 'react-redux';
import { selectMissionsState } from '../screens/Missions/selectors';
import { getText, TEXT_KEY } from '../utils/localization';
import { getCurrentTimestamp } from '../utils/TimestampManager';
var TOOLTIP_DURATION = 3000;
var PROGRESS_COMPLETE = 100;
var useMissionsTooltips = function useMissionsTooltips(props) {
  var _missionsState$data$m, _missionsState$data;
  var currentMission = props.currentMission,
    shouldShowTooltip = props.shouldShowTooltip,
    tooltipDetails = props.tooltipDetails,
    missionFinishedTooltipDetail = props.missionFinishedTooltipDetail,
    battlesInProgressTooltipDetail = props.battlesInProgressTooltipDetail,
    modal = props.modal,
    showMissionsProgressBar = props.showMissionsProgressBar,
    navigation = props.navigation,
    _props$battlesRunning = props.battlesRunning,
    battlesRunning = _props$battlesRunning === void 0 ? false : _props$battlesRunning,
    _props$isCollectStatu = props.isCollectStatus,
    isCollectStatus = _props$isCollectStatu === void 0 ? false : _props$isCollectStatu,
    _props$isMissionsScre = props.isMissionsScreen,
    isMissionsScreen = _props$isMissionsScre === void 0 ? false : _props$isMissionsScre,
    _props$isBattlesScree = props.isBattlesScreen,
    isBattlesScreen = _props$isBattlesScree === void 0 ? false : _props$isBattlesScree;
  var missionsState = useSelector(selectMissionsState);
  var missionsGameplayStatus = (_missionsState$data$m = missionsState === null || missionsState === void 0 || (_missionsState$data = missionsState.data) === null || _missionsState$data === void 0 || (_missionsState$data = _missionsState$data.missionsFeature) === null || _missionsState$data === void 0 ? void 0 : _missionsState$data.missionsGameplayStatus) !== null && _missionsState$data$m !== void 0 ? _missionsState$data$m : null;
  var _ref = currentMission || {},
    clientProgress = _ref.clientProgress,
    serverProgress = _ref.serverProgress,
    goalMessage = _ref.goalMessage,
    missionStatus = _ref.missionStatus,
    _ref$endTimestamp = _ref.endTimestamp,
    endTimestamp = _ref$endTimestamp === void 0 ? null : _ref$endTimestamp;
  var hasShownMiddleTooltip = useRef(false);
  var animationOut = useMemo(function () {
    return utils.isWebOrMobileWeb() ? 'AnimationSlideToTop' : 'out';
  }, []);
  var showTooltipWithTimeout = useCallback(function (detail) {
    tooltipDetails(detail);
    shouldShowTooltip(true);
    setTimeout(function () {
      tooltipDetails(_objectSpread(_objectSpread({}, detail), {}, {
        animationState: animationOut
      }));
      shouldShowTooltip(false);
    }, TOOLTIP_DURATION);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var isMissionComplete = useMemo(function () {
    return Math.round(serverProgress) >= PROGRESS_COMPLETE;
  }, [serverProgress]);
  var handleMissionEndTooltip = useCallback(function () {
    if (isMissionComplete && missionsGameplayStatus !== MISSIONS_GAMEPLAY_STATUS.TUTORIAL && !modal && showMissionsProgressBar) {
      showTooltipWithTimeout(missionFinishedTooltipDetail);
    }
  }, [isMissionComplete, missionsGameplayStatus, modal, showMissionsProgressBar, showTooltipWithTimeout, missionFinishedTooltipDetail]);
  var handleBattlesMiddleTooltip = useCallback(function () {
    if (Math.floor(clientProgress) >= 50 && Math.floor(clientProgress) < 65 && !isCollectStatus && getCurrentTimestamp() < endTimestamp && !hasShownMiddleTooltip.current && missionsGameplayStatus !== MISSIONS_GAMEPLAY_STATUS.TUTORIAL && !modal && showMissionsProgressBar) {
      var detail = _objectSpread(_objectSpread({}, missionFinishedTooltipDetail), {}, {
        title: getText(TEXT_KEY.BATTLES_TOOLTIP_HALFWAY)
      });
      showTooltipWithTimeout(detail);
      hasShownMiddleTooltip.current = true;
    }
  }, [clientProgress, isCollectStatus, endTimestamp, missionsGameplayStatus, modal, showMissionsProgressBar, missionFinishedTooltipDetail, showTooltipWithTimeout]);
  useEffect(function () {
    !battlesRunning && handleMissionEndTooltip();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverProgress, modal, battlesRunning]);
  useEffect(function () {
    battlesRunning && handleBattlesMiddleTooltip();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientProgress, modal, battlesRunning]);
  var onProgressPressHandler = function onProgressPressHandler() {
    if (battlesRunning && !hasSomeCompleteState(missionStatus) && serverProgress !== 100 && !isCollectStatus) {
      showTooltipWithTimeout(battlesInProgressTooltipDetail);
      return;
    }
    if (!battlesRunning && serverProgress < 100) {
      var tooltipText = generateDescription('', {
        goalMessage: goalMessage
      });
      showTooltipWithTimeout(_objectSpread(_objectSpread({}, missionFinishedTooltipDetail), {}, {
        title: tooltipText
      }));
      return;
    }
    !isMissionsScreen && !isBattlesScreen && QueryParamsProxy.navigate(navigation, Screens.Missions);
  };
  return {
    onProgressPressHandler: onProgressPressHandler
  };
};
export default useMissionsTooltips;